import React,{ useState } from 'react';

import Lottie from 'react-lottie';
// import animationData from './lotties/Dash-Loading-Logo.json';
import animationData from './lotties/Dash-Loading-Logo-white.json';

// loading-wrap
// css style can be found in App.css file

export default function LoadingIndicator({quoteContent, fanClubContent}) {

    const [quoteContentShow, setQuoteContentShow] = useState(quoteContent);
    const [quoteFromContentShow, setQuoteFromContentShow] = useState(fanClubContent);

    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
    };

    return (

        <div className="loading-wrap-otherpage">
            <div className="loading-lottie-otherpage">
                <div className='loading-lottie-logo'>
                <Lottie 
                    className=""
                    options={defaultOptions}
                    // height={"100%"}
                    // width={"100%"}
                    isClickToPauseDisabled={true}
                />

                </div>
                <h5 className='text-white loading-quote'>{quoteContentShow}</h5>
                <h6 className='text-white text-center'>{quoteFromContentShow}</h6>

            </div>
        </div>
        // <div className="loading-wrap-otherpage">
        //     <div className="loading-lottie-otherpage">
        //         <Lottie 
        //             options={defaultOptions}
        //             height={"100%"}
        //             width={"100%"}
        //             isClickToPauseDisabled={true}
        //         />
        //     </div>
        // </div>
    );
}